module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-left-24px.2ec03950.svg";